import { computed } from 'vue'
import { useDisplay } from 'vuetify'
import { BREAKPOINTS, MOBILE_BREAKPOINT } from '@/constants/breakpoints'

/**
 * Único criterio de "esto es móvil" de la app.
 *
 * Usar esto y no `useDisplay().mobile`: el breakpoint `mobile` de Vuetify son
 * 1280px, mientras que el layout cambia a 960px, así que mezclarlos hacía que
 * unas vistas cambiaran a móvil antes que otras.
 */
export function useBreakpoints() {
  const { width } = useDisplay()

  const isMobile = computed(() => width.value < MOBILE_BREAKPOINT)
  const isTablet = computed(() => width.value >= BREAKPOINTS.sm && width.value < BREAKPOINTS.lg)
  const isDesktop = computed(() => width.value >= MOBILE_BREAKPOINT)
  const isCompact = computed(() => width.value < BREAKPOINTS.sm)

  return { width, isCompact, isMobile, isTablet, isDesktop }
}
